import React from 'react'
import { Button } from 'react-bootstrap'
import { createPortal } from 'react-dom'
import Modal from '../wrapper'

const ErrorModal = ({
    children,
    centered,
    title,
    onHide = () => {},
}) => {
    return createPortal(
        <Modal
            onHide={onHide}
            closeButton
            centered={centered}
        >
            <div style={{ minHeight: '100px', padding: '20px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'center'}}>
                <div>
                    {title ? title : 'Error!'}
                </div>    
                {children}
                <div style={{ display: 'flex', justifyContent: 'space-around'}}>
                    <Button onClick={() => onHide()}>Close</Button>
                </div>
            </div>
        </Modal>
        , document.body)
}

export default ErrorModal